import * as React from "react";

function SvgInfo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8a8 8 0 1016 0A8 8 0 000 8zm14 0A6 6 0 112 8a6 6 0 0112 0zm-4.996 2.998H7.003v-4h2v4zm-.003-6a1 1 0 11-2 0 1 1 0 012 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgInfo;
